import React from 'react';
import './SmartBadge.css';

/**
 * props:
 * -id
 * - text
 * - onClick
 */
function SmartBadge(props) {
    return (
        <div className="smart-badge">
            <span className="smart-badge__label alert alert-info py-1">
                {props.children} {props.text}
            </span>
            <button
                id={props.id}
                type="button"
                className="smart-badge__remove btn btn-info btn-xs alert"
                title="Click to Remove"
                onClick={props.onClick}
            >
                X
            </button>
        </div>
    )
}

export default SmartBadge;